import { typeRootState } from 'src/store';
import { useSelector } from 'react-redux';

export const useGetShowingLoadingModal = () => {
    const showingLoadingModal = useSelector((state: typeRootState) => state.loadingModal.showingLoadingModal);
    return showingLoadingModal;
}
